import React from 'react';
import { observer } from 'mobx-react-lite';
import {useAppStateContext} from 'src/AppState/AppState';
import { ColumnWrapper, MarketName, ActionButton, ColumnHeader, FilterList, DraggableButton, FilterListItem, MarketsForFilterItemContent, Note } from 'src/components/SportPopup/MarketFilters/MarketFilters.style';
import { List } from 'react-movable';
import {MinusCircleIcon} from 'src/assets/icons/MinusCircleIcon';
import {DragAndDropIcon} from 'src/assets/icons/DragAndDropIcon';

interface MarketsForFiltersPropsType {
    sportName: string
}

export const MarketsForFilter = observer(({sportName}: MarketsForFiltersPropsType) => {

    const { marketFiltersState } = useAppStateContext();
    const { marketsBySelectedFilter, removeMarketFromFilter, changeMarketsOrderHandler, selectedFilter, currentSport } = marketFiltersState.get(sportName);

    if (selectedFilter !== null && selectedFilter.filter_slug === 'all_markets') {
        return (
            <ColumnWrapper>
                <ColumnHeader>Market Display Order:</ColumnHeader>
                <div>
                Market display order for all markets can be change in Market templates tab
                </div>
            </ColumnWrapper>
        );
    }


    return (
        <ColumnWrapper>
            <ColumnHeader>Market Display Order:</ColumnHeader>
            {marketsBySelectedFilter.length > 0 ?
                <List
                    lockVertically
                    values={marketsBySelectedFilter}
                    onChange={changeMarketsOrderHandler}
                    renderList={({ children, props, isDragged }): JSX.Element => (<FilterList {...props} style={{cursor: isDragged ? 'grabbing' : 'inherit'}}>{children}</FilterList>)}
                    renderItem={({ value, props, isDragged, index }): JSX.Element | null => {
                        return (
                            <div key={`${index}-${value.market_id}-${selectedFilter?.id}`}>
                                {index === 5 && selectedFilter?.filter_name.toLocaleLowerCase() !== 'popular' ? <Note {...props} key={`${index}-${value.market_id}-${selectedFilter?.id}-note`}>Note: Markets below will show collapsed</Note> : null}
                                <FilterListItem {...props} isDragged={isDragged} >
                                    <DraggableButton
                                        data-movable-handle
                                        style={{
                                            cursor: isDragged ? 'grabbing' : 'grab'
                                        }}
                                        tabIndex={-1}
                                    >
                                        <DragAndDropIcon />
                                    </DraggableButton>
                                    <MarketsForFilterItemContent>
                                        <MarketName>{value.market_name}</MarketName>
                                        <ActionButton onClick={() => removeMarketFromFilter(value.market_id, currentSport)}> <MinusCircleIcon /> </ActionButton>
                                    </MarketsForFilterItemContent>
                                </FilterListItem>

                            </div>);
                    }}
                /> :
                <div> Add market for this filter</div>}
        </ColumnWrapper>
    );
});
